import { Routes } from '@angular/router';
import { WebInscripcionesComponent } from './web-inscripciones/web-inscripciones.component';
import { WebInscripcionesErrorTpvComponent } from './web-inscripciones-error-tpv/web-inscripciones-error-tpv.component';
import { WebInscripcionesFinishComponent } from './web-inscripciones-finish/web-inscripciones-finish.component';

const auto_redirect = "/inscript";

export const routes: Routes = [
    { path: '', redirectTo: auto_redirect, pathMatch: 'full' },
    { path: 'inscript', component: WebInscripcionesComponent },
    { path: 'inscript/errortpv', component: WebInscripcionesErrorTpvComponent },
    { path: 'inscript/finish', component: WebInscripcionesFinishComponent },
];